"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Traverses the DOM upwards and checks the computed styles
 * of each element it passes. Compares the value of the
 * requested property with the passed value and returns
 * the element if the value is a match
 *
 * @param   {HTMLElement} element Element to start from.
 * @param   {string} property CSS property to search for.
 * @param   {string} value Value to compare CSS property value with.
 * @returns {HTMLElement|null}
 */
var findParentWithCSS = function findParentWithCSS(element, property, value) {
  while (element !== null) {
    var style = window.getComputedStyle(element);
    var propValue = style.getPropertyValue(property);

    if (propValue === value) {
      return element;
    }

    element = element.parentElement; // eslint-disable-line
  }

  return null;
};

var _default = findParentWithCSS;
exports.default = _default;